class RebuyGiftWithPurchaseManager {
  defaults() {
    return {
      // Rebuy default
      rebuy_cart_selector: "#rebuy-cart",
      rebuy_section_selector: "[data-rebuy-component='cross-sell-widget']",
      // Custom
      container_id: "custom-rebuy-gift-with-purchase",
      subtotal_cart_minimum: 10000, // 100.00
      gift_items: [],
      cart_gift_item: null,
      title: "CHOOSE A FREE GIFT!",
      unlocked_description: "You've unlocked all gift tiers!",
      locked_description: "Spend $[[left]] unlock next gift tier!",
    };
  }

  constructor(options) {
    this.config = { ...this.defaults(), ...options };
    this.init();
  }

  init() {
    document.addEventListener("rebuy:smartcart.ready", (event) => {
      this.render_gift_with_purchase();
    });

    document.addEventListener("rebuy:smartcart.show", (event) => {
      const cart = event.detail.smartcart;
      const subtotal = cart.cart.items_subtotal_price;
      const items = cart.items();

      this.render_gift_with_purchase();

      this.find_cart_gift_item(items);
      this.handle_subtotal_change(subtotal);
      this.handle_show_grid();
    });

    document.addEventListener("rebuy:cart.change", (event) => {
      const cart = event.detail.cart;
      const subtotal = cart.subtotal();
      const items = cart.items();

      this.find_cart_gift_item(items);
      this.handle_subtotal_change(subtotal);
      this.handle_show_grid();
    });
  }

  handle_subtotal_change(subtotal = null) {
    if (!subtotal) subtotal = window.Rebuy.Cart.subtotal();

    if (subtotal < this.config.subtotal_cart_minimum) {
      this.remove_gift_with_purchase();
      this.lock_add_to_cart_buttons();
    } else {
      this.unlock_add_to_cart_buttons();
    }
    this.handle_show_grid();
    this.update_description(subtotal);
  }

  handle_show_grid() {
    const rebuyCart = document.querySelector(this.config.rebuy_cart_selector);
    if(!rebuyCart) return;

    const grid = rebuyCart.querySelector(".rebuy-product-grid");
    if (!grid) return;

    this.find_cart_gift_item();
    if (this.config.cart_gift_item) {
      grid.classList.add("d-none");
    } else {
      grid.classList.remove("d-none");
    }
  }

  update_description(subtotal = null) {
    if (!subtotal) subtotal = window.Rebuy.Cart.subtotal();

    const rebuyCart = document.querySelector(this.config.rebuy_cart_selector);
    const description = rebuyCart.querySelector(".rebuy-description-txt");

    let descriptionText;

    if (subtotal < this.config.subtotal_cart_minimum) {
      const left = (this.config.subtotal_cart_minimum - subtotal) / 100;
      descriptionText = this.config.locked_description.replace(
        "[[left]]",
        left.toFixed(2)
      );
    } else if (subtotal >= this.config.subtotal_cart_minimum) {
      descriptionText = this.config.unlocked_description;
    }

    if (description) description.textContent = descriptionText;
    return descriptionText;
  }

  find_cart_gift_item(items = null) {
    if (!items) items = window.Rebuy.Cart.items();

    const cartGiftItem = items.find((item) => {
      return item.properties && item.properties._widget_id == "XXXXXX";
    });

    if (cartGiftItem) {
      this.config.cart_gift_item = cartGiftItem;
      // TODO: remove extra gift items
    } else {
      this.config.cart_gift_item = null;
    }
  }

  remove_gift_with_purchase() {
    if (!this.config.cart_gift_item) {
      this.find_cart_gift_item();
    }
    if (this.config.cart_gift_item) {
      window.Rebuy.Cart.removeItem(this.config.cart_gift_item);
      this.config.cart_gift_item = null;
    }
  }

  lock_add_to_cart_buttons() {
    const buttons = document.querySelectorAll(".custom-rebuy-add-to-cart");
    buttons.forEach((button) => {
      button.setAttribute("disabled", "disabled");
      button.querySelector("span").textContent = "Locked";
    });
  }

  unlock_add_to_cart_buttons() {
    const buttons = document.querySelectorAll(".custom-rebuy-add-to-cart");
    buttons.forEach((button) => {
      button.removeAttribute("disabled");
      button.querySelector("span").textContent = "Add";
    });
  }

  add_event_listeners() {
    const buttons = document.querySelectorAll(".custom-rebuy-add-to-cart");
    buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = event.currentTarget.getAttribute("data-variant-id");
        window.Rebuy.Cart.addItem({
          id: variantId,
          properties: {
            _attribution: "Rebuy Smart Cart",
            _widget_id: "XXXXXX",
            _source: "Rebuy",
          },
          quantity: 1,
        });
      });
    });
  }

  render_review({ review_avg, review_stars, review_count }) {
    return `<div class="rebuy-product-review">
      <span class="rebuy-star-rating sr-only">
        <span class="rebuy-star-rating-value sr-only">
          ${review_avg} stars out of 5 stars
        </span>
        <span class="rebuy-star-rating-background"></span>
        <span
          class="rebuy-star-rating-foreground"
          style="width: ${review_stars}%;"
        ></span>
      </span>
      <span class="rebuy-review-count">
        <span class="rebuy-review-count-parenthesis">(</span>
        <span class="rebuy-review-count-number">${review_count}</span>
        <span class="rebuy-review-count-label">Reviews</span>
        <span class="rebuy-review-count-parenthesis">)</span>
      </span>
    </div>`;
  }

  render_product_card({
    product_id,
    product_tags,
    product_handle,
    product_img,
    product_title,
    product_img_alt,
    variant_id,
    review_avg,
    review_stars,
    review_count,
  }) {
    const tagsArray = product_tags
      .split(" ")
      .filter((tag) => tag.trim() !== "");
    const tagsClass = tagsArray.map((tag) => tag).join(" ");

    return `
      <div class="rebuy-product-block product-id-${product_id} ${tagsClass}">
        <div class="rebuy-product-media">
          <a href="/product/${product_handle}?variant=${variant_id}" class="rebuy-product-image clickable">
            <img loading="eager" src="${product_img}" alt="View ${product_img_alt}">
          </a>
        </div>
        <div class="rebuy-product-info">
          <a href="/products/${product_handle}" class="rebuy-product-title clickable">
            ${product_title}
          </a>
          ${this.render_review({ review_avg, review_stars, review_count })}
        </div>
        <div class="rebuy-product-actions">
          <button alt="Add ${product_title} to Cart" type="button" class="rebuy-button custom-rebuy-add-to-cart" data-variant-id="${variant_id}">
            <span>Add</span>
          </button>
        </div>
      </div>`;
  }

  render_container() {
    const widget = document.createElement("div");
    widget.id = this.config.container_id;

    const productGrid = this.config.gift_items
      .map((item) => this.render_product_card(item))
      .join("");

    widget.innerHTML = `
      <div id="rebuy-widget-XXXXXX" class="rebuy-widget widget-type-cart widget-display-embed is-visible widget-layout-line">
        <div class="rebuy-widget-container widget-display-embed is-visible">
          <div class="rebuy-widget-content">
            <h4 class="primary-title">${this.config.title}</h4>
            <p class="rebuy-description-txt">${this.update_description()}</p>
            <div class="rebuy-product-grid large-style-line large-columns-1 medium-style-line medium-columns-1 small-style-line small-columns-1">
              ${productGrid}
            </div>
          </div>
        </div>
      </div>
    `;

    return widget;
  }

  render_gift_with_purchase(forceRender = false) {
    const rebuyCart = document.querySelector(this.config.rebuy_cart_selector);
    const section = rebuyCart.querySelector(this.config.rebuy_section_selector);
    const firstChild = section.firstChild;

    if (!(firstChild && firstChild.id === this.config.container_id)) {
      const mockup = this.render_container();
      section.insertBefore(mockup, firstChild);
      this.add_event_listeners();
    } else if (forceRender) {
      section.removeChild(firstChild);
      const mockup = this.render_container();
      section.insertBefore(mockup, firstChild);
      this.add_event_listeners();
    }
  }
}
